import React from 'react';
import { Section } from './ui/Section';
import { MoonIcon, HeartIcon, SparklesIcon, EyeOffIcon } from 'lucide-react';
export function Benefits() {
  const benefits = [{
    icon: MoonIcon,
    title: 'Acompaña sin desvelar',
    description: 'Luz suave que permite ver la habitación sin interrumpir la producción de melatonina.'
  }, {
    icon: HeartIcon,
    title: 'Seguridad emocional',
    description: "Transforma el 'cuarto oscuro' en un planetario personal, reduciendo el miedo nocturno."
  }, {
    icon: SparklesIcon,
    title: 'Rutina mágica',
    description: "Ayuda a establecer el momento de 'bajar revoluciones' antes de dormir."
  }, {
    icon: EyeOffIcon,
    title: 'Sin pantallas',
    description: 'Entretenimiento visual analógico y relajante, lejos de tablets y celulares.'
  }];
  return <Section data-id="element-15">
      <h2 className="text-2xl md:text-3xl font-bold text-[#111827] mb-8 text-center" data-id="element-16">
        Más que una luz de noche
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-17">
        {benefits.map((benefit, index) => <div key={index} className="flex gap-4 p-4 rounded-xl border border-gray-100 hover:border-pink-100 hover:shadow-sm transition-all" data-id="element-18">
            <div className="flex-shrink-0" data-id="element-19">
              <div className="w-12 h-12 bg-pink-50 rounded-full flex items-center justify-center text-[#E6007A]" data-id="element-20">
                <benefit.icon className="w-6 h-6" data-id="element-21" />
              </div>
            </div>
            <div data-id="element-22">
              <h3 className="font-bold text-[#111827] mb-1" data-id="element-23">{benefit.title}</h3>
              <p className="text-[#4B5563] text-sm leading-relaxed" data-id="element-24">
                {benefit.description}
              </p>
            </div>
          </div>)}
      </div>
    </Section>;
}